// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const DnsRrTypeSchema = z.enum(['A','AAAA','CNAME','MX','NS','SOA','TXT','SRV','PTR','CAA','NAPTR','TLSA','SSHFP','DS','DNSKEY','HTTPS','SVCB','URI','DNAME','HINFO','CERT','RP','NSEC','NSEC3','RRSIG','OTHER'] as const);

export type DnsRrTypeType = `${z.infer<typeof DnsRrTypeSchema>}`

export default DnsRrTypeSchema;
